// Implement a stress test on BIMSearch
import { getNextLevel } from "./IModelsTree";
import { loggedIn } from "./IUsers";

export async function stressTest(name) {
    var nums = name.split("#");
    var users, iterations;
    if (nums.length == 3) {
        users = parseInt(nums[1]);
        iterations = parseInt(nums[2]);
    }

    for (var i = 0; i < users; i++) {
        stressTestLoop(i, iterations);
    }
}

async function stressTestLoop(user, iterations) {
    for (var i = 0; i < iterations; i++) {
        console.log("**** Stress test, user-" + user + " iteration " + i + " started");
        var res = await loggedIn();
        if (res == false) {
            console.log("**** Stress test, user-" + user + " iteration " + i + " Failled");
            return;
        }
        //getUserData();

        var res = await getNextLevel("#");
        await openAllLevels(res);
        console.log("**** Stress test, user-" + user + " iteration " + i + " ended");
    }

}

async function openAllLevels(level) {
    for (var i = 0; i < level.length; i++) {
        if (level[i].children) {
            var res = await getNextLevel(level[i].id);
            await openAllLevels(res);
        }
    }
}
